<script lang="ts">
	import { onMount } from 'svelte';
	import type { HDGameReportResponseData } from '../types/responses/GameReport.js';
	import dayjs from 'dayjs';

	let {
		game
	}: {
		game: HDGameReportResponseData;
	} = $props();

	let diff = $derived(Math.max(0, -dayjs().diff(game.gameData.scheduledDate.timestamp, 'seconds')));

	const countdown = $derived.by(() => {
		const d = Math.floor(diff / 86400);
		const h = Math.floor((diff % 86400) / 3600);
		const m = Math.floor(((diff % 86400) % 3600) / 60);
		const s = Math.floor(((diff % 86400) % 3600) % 60);
		return { d, h, m, s };
	});

	onMount(() => {
		setInterval(() => {
			diff = Math.max(0, -dayjs().diff(game.gameData.scheduledDate.timestamp, 'seconds'));
		}, 1000);
	});
</script>

{#snippet countdownComponent(time: number, label: string)}
	<div class="flex flex-col">
		<span class="countdown text-6xl font-bold">
			<span style={`--value:${time}`} aria-live="polite" aria-label={time.toString()}>
				{time}
			</span>
		</span>
		{label}
	</div>
{/snippet}

<div class="flex flex-col items-center gap-3 p-3 text-center">
	<div class="grid grid-cols-2 items-center justify-center gap-3 sm:grid-cols-4">
		{@render countdownComponent(countdown.d, 'Tage')}
		{@render countdownComponent(countdown.h, 'Stunden')}
		{@render countdownComponent(countdown.m, 'Minuten')}
		{@render countdownComponent(countdown.s, 'Sekunden')}
	</div>
</div>
